import BaseDropDownPicker, { BaseDropDownPickerProps } from '@/components/Form/BaseDropDownPicker';
import { DropDownDirectionType, ValueType } from 'react-native-dropdown-picker';
import { FormChildProp } from '@/components/Form/types';
import React, { useEffect, useState } from 'react';
import { Text, useTheme } from 'react-native-paper';
import { Platform, StyleSheet, View } from 'react-native';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import HelpButton from '@/components/HelpButton';

const DropDownInput = React.forwardRef(
  <T extends ValueType>(
    props: Omit<BaseDropDownPickerProps<T>, 'value' | 'setValue'> &
      FormChildProp & { defaultValue?: T | T[] | null; value?: T | T[] | null },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref
  ): React.ReactElement => {
    const {
      defaultValue,
      onChangeValue,
      error,
      containerStyle,
      value,
      name,
      label,
      labelStyle,
      withHelpButton = false,
      helpFieldName,
      ...rest
    } = props;
    const theme = useTheme();

    const [valueSet, setValueSet] = useState<T | T[] | null | undefined>(
      value !== undefined ? value : defaultValue
    );

    const [direction, setDirection] = useState<DropDownDirectionType>('BOTTOM');
    const [open, setOpen] = useState(false);

    const currentValue = useWatch({ name: name, defaultValue });

    const { t } = useTranslation();

    useEffect(() => {
      if (onChangeValue && valueSet !== value) {
        const finalValue =
          valueSet !== undefined ? valueSet : value !== undefined ? value : defaultValue;
        onChangeValue(finalValue);
      }
    }, [valueSet]);

    useEffect(() => {
      if (valueSet !== currentValue) {
        setValueSet(currentValue);
      }
    }, [currentValue]);

    console.log(direction.toUpperCase());

    return (
      <View
        style={[
          {
            flexDirection: 'column',
            alignSelf: 'stretch',
          },
          Platform.OS === 'web'
            ? { zIndex: 'auto' }
            : {
                zIndex: open
                  ? direction.toUpperCase() === 'TOP'
                    ? rest.zIndex
                    : rest.zIndexInverse
                  : 0,
              },
          containerStyle,
        ]}
      >
        {label ? (
          withHelpButton && (helpFieldName || name) ? (
            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 4 }}>
              <Text variant={'labelMedium'} style={[styles.label, { marginBottom: 0 }, labelStyle]}>
                {t(label)}
              </Text>
              <HelpButton
                fieldName={helpFieldName || name || ''}
                size={16}
                style={{ marginLeft: 4 }}
              />
            </View>
          ) : (
            <Text variant={'labelMedium'} style={[styles.label, labelStyle]}>
              {t(label)}
            </Text>
          )
        ) : null}
        <BaseDropDownPicker<T>
          maxHeight={130}
          {...rest}
          style={[styles.input, Platform.OS === 'web' ? { zIndex: 'auto' } : {}, rest.style]}
          value={valueSet !== undefined ? valueSet : null}
          error={error?.message !== undefined}
          onDirectionChanged={(direction) => setDirection(direction)}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          // @ts-ignore
          setValue={setValueSet}
        />
        {error?.message ? (
          <Text
            variant={'labelMedium'}
            style={{
              color: theme.colors.error,
              marginLeft: 18,
              marginTop: 4,
            }}
          >
            {props.error?.message}
          </Text>
        ) : null}
      </View>
    );
  }
);

export default DropDownInput;

const styles = StyleSheet.create({
  label: {
    paddingBottom: 5,
  },
});
